/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  OperationTypes,
  OperationTypeState
} from '@/store/interfaces/operationType';
import { RootState } from '@/store/interfaces/rootState';
import operationType from '@/store/types/operationType';
import { httpCommpix } from '@/util/HTTPCommpix';
import { AxiosError, AxiosResponse } from 'axios';
import { ActionTree, GetterTree, MutationTree } from 'vuex';

const namespaced = true;

const initialState = (): OperationTypeState => {
  return {
    operationTypesList: [],
  };
};

const state: OperationTypeState = initialState();

const getters: GetterTree<OperationTypeState, RootState> = {
  [operationType.getters.GET_OPERATION_TYPES_LIST]: state => {
    return state.operationTypesList;
  },
};

const mutations: MutationTree<OperationTypeState> = {
  reset: (state: any) => {
    const initialStateFields: any = initialState();
    Object.keys(initialStateFields).forEach((key: any) => {
      state[key] = initialStateFields[key];
    });
  },

  [operationType.mutations.SET_OPERATION_TYPES_LIST]: (
    state,
    states: Array<OperationTypes>
  ) => {
    const operationTypes: Array<OperationTypes> = states;

    state.operationTypesList = operationTypes;
  },
};

const actions: ActionTree<OperationTypeState, RootState> = {
  [operationType.actions.OPERATION_TYPES_LIST]: (
    { commit, }
  ) => {
    return new Promise((resolve, reject) => {
      httpCommpix
        .get('/operation-types')
        .then((res: AxiosResponse) => {
          commit(
            operationType.mutations.SET_OPERATION_TYPES_LIST,
            res.data
          );
          resolve(res);
        })
        .catch((error: AxiosError) => {
          reject(error);
        });
    });
  },
};

export default {
  namespaced,
  state,
  getters,
  mutations,
  actions,
};
